import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Studio from "@/pages/Studio";
import Gallery from "@/pages/Gallery";
import MovieDetail from "@/pages/MovieDetail";
import Share from "@/pages/Share";
import Navbar from "@/components/Navbar";

export default function App() {
  return (
    <div className="App min-h-screen bg-[#050505] text-[#F5F5F5]">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<><Navbar /><Studio /></>} />
          <Route path="/gallery" element={<><Navbar /><Gallery /></>} />
          <Route path="/movie/:id" element={<><Navbar /><MovieDetail /></>} />
          <Route path="/share/:id" element={<Share />} />
        </Routes>
      </BrowserRouter>
      <Toaster theme="dark" position="bottom-right" richColors closeButton />
    </div>
  );
}
